import { Dialog } from '@headlessui/react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTranslation from '../../../../../hooks/useTranslations';
import { closeFavoritesDeleteModal, removeFavoriteList, openFavoritesDeleteModal, selectFavoritesDeleteModalIsOpen, selectActiveFavoriteListId } from '../../../../../redux/modules/favoritesSlice';
import ModalWrapper from '../../../layouts/partials/ModalWrapper';

const DeleteFavoritesModal = () => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const isFavoritesModalOpen = useSelector((state) => (selectFavoritesDeleteModalIsOpen(state)));
	const activeFavoriteListId = useSelector((state) => (selectActiveFavoriteListId(state)));

	const setIsModalOpen = useCallback((shouldOpen) => {
		if (shouldOpen) {
			dispatch(openFavoritesDeleteModal());
		} else {
			dispatch(closeFavoritesDeleteModal());
		}
	}, [dispatch]);

	const remove = () => {
		dispatch(removeFavoriteList({ favoriteListId: activeFavoriteListId }));
		setIsModalOpen(false);
	};

	return (
		<ModalWrapper isModalOpen={isFavoritesModalOpen} setIsModalOpen={setIsModalOpen} maxWidth="max-w-sm">
			<Dialog.Title
				as="h3"
				className="text-[1.25rem] font-semibold text-oly-gray-darkest text-center mb-4"
			>
				{t('favorite_list_remove_alert_title_singular')}
			</Dialog.Title>
			<Dialog.Description
				as="p"
				className="text-[1.0625rem] text-oly-gray-darkest text-center mb-8 leading-6"
			>
				{t('my_files_confirm_deletion_text')}
			</Dialog.Description>
			<div className="flex -mx-6 border-t divide-x border-oly-gray-lightest divide-oly-gray-lightest">
				<button
					type="button"
					className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-normal text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
					onClick={() => setIsModalOpen(false)}
				>
					{t('bookmarks_remove_cancel')}
				</button>
				<button
					type="button"
					className="text-left flex-1 h-16 inline-flex justify-center items-center flex-grow px-4 py-2 text-[0.9375rem] font-semibold text-oly-blue-dark can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none disabled:text-oly-gray-normal disabled:!bg-white disabled:cursor-not-allowed disabled:opacity-75"
					onClick={() => remove()}
				>
					{t('general_ok')}
				</button>
			</div>
		</ModalWrapper>
	);
};

export default DeleteFavoritesModal;
